// Material Dashboard 2 PRO React components
import { MDInput } from "../MDInput";

interface IFormFieldProps {
  label?: string;
  [rest: string]: any;
}

export const FormField: React.FC<IFormFieldProps> = ({label, ...rest} : IFormFieldProps) => {
  return <MDInput variant="standard" label={label} fullWidth {...rest} />;
}
